export default __webpack_public_path__ + "static/media/app_icon.52643a95.png";